/**
 * Banner lines above the search composer.
 *
 * A brand+model query has no language signal, so the model often writes the
 * done-turn stand-by in English. That line is chrome (like the loading
 * footer) and must follow the site locale.
 */
export const STAND_BY_FALLBACK =
  'Stand by while we pull up the best options for you.';

export function bannerCopyForTurn({
  isDone,
  message,
  prompt,
  standByMessage,
}: {
  isDone?: boolean;
  message?: string | null;
  prompt: string | null;
  standByMessage?: string;
}): { preamble: string | null; question: string | null; standBy: boolean } {
  if (isDone) {
    return {
      preamble: null,
      question: standByMessage || STAND_BY_FALLBACK,
      standBy: true,
    };
  }
  return {
    preamble: message ?? null,
    question: prompt,
    standBy: false,
  };
}
